module.exports = __webpack_public_path__ + "img/604.530c0131.png";